import React, {useEffect, useRef, useState} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import {useLoggedInStatus} from "../../../hooks";
import Container from "../Container";
import {Button, CustomLink, Image} from "../../common";
import {RouteDictionary} from "../../../utils";
import {LogoImage} from "../../common/images/types";
import {LogoType} from "../../common/images/types/LogoImage";
import ProfileMenu from "../../user/profile/ProfileMenu";
import arrow from 'assets/images/svg/arrow-diagonal.svg';
import cross from 'assets/images/svg/cross-enter.svg';
import burger from 'assets/images/svg/burger.svg';
import styles from "./HeaderNew.module.scss";
import {useWindowWidth} from "../../pages/detailed-project/hooks";

const publicLinks = [
  {
    to: RouteDictionary.FAQ,
    text: "FAQ",
  },
  // {
  //   to: RouteDictionary.HOW_IT_WORKS,
  //   text: "Как это работает",
  // },
];

const HOW_IT_WORKS_SECTION_ID = "how";
const HOME_URL = "/";

export const HeaderPublic = () => {
  const isLoggedIn = useLoggedInStatus();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isBurgerOpen, setIsBurgerOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const burgerRef = useRef<HTMLDivElement>(null);
  const isMobile = useWindowWidth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleHowItWorksClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    setIsBurgerOpen(false);
    if (location.pathname === HOME_URL) {
      document.getElementById(HOW_IT_WORKS_SECTION_ID)?.scrollIntoView({behavior: "smooth"});
    } else {
      navigate(`${HOME_URL}#${HOW_IT_WORKS_SECTION_ID}`);
    }
  };

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const closeDropdown = () => {
    setIsDropdownOpen(false);
  };

  const toggleBurger = () => {
    setIsBurgerOpen(!isBurgerOpen);
  };

  const closeBurger = () => {
    setIsBurgerOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsDropdownOpen(false);
      }
    };

    if (isDropdownOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isDropdownOpen]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (burgerRef.current && !burgerRef.current.contains(event.target as Node)) {
        setIsBurgerOpen(false);
      }
    };

    if (isBurgerOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isBurgerOpen]);

  const renderNavLinks = (linkClassName: string) => <>
    {publicLinks.map((link, index) => (
      <CustomLink key={index} to={link.to} className={linkClassName} onClick={closeBurger}>
        <div>{link.text}</div>
      </CustomLink>
    ))}
    <a
      href={`${HOME_URL}#${HOW_IT_WORKS_SECTION_ID}`}
      className={linkClassName}
      onClick={handleHowItWorksClick}
    >
      <div>Как это работает</div>
    </a>
  </>;

  return <header className={`${styles.header} ${styles['header--public']}`}>
    <Container>
      <div className={`${styles.logo__container} ${styles['logo__container--public']}`}>
        <CustomLink to={RouteDictionary.INDEX}>
          <LogoImage className={styles.logo} type={isMobile? LogoType.MOBILE: LogoType.LOGO_TEXT}/>
        </CustomLink>
        <nav className={styles.public__nav}>
          <div className={styles.public__nav__left}>
            <div className={styles.public__links__container}>
              {renderNavLinks(styles.public__link)}
            </div>
          </div>
        </nav>
        <div className={styles.public__nav__right}>
          { !isLoggedIn ?
            <div className={styles.public} ref={dropdownRef}>
              <Button 
                className={`${styles.public__buttonEnter} ${isDropdownOpen ? styles.public__buttonEnter__active : ''}`}
                onClick={toggleDropdown}
              >
                Личный кабинет
                <Image 
                  src={arrow} 
                  alt='arrow' 
                  className={`${styles.public__arrow} ${isDropdownOpen ? styles.public__arrow__rotated : ''}`}
                />
              </Button>
              <div className={`${styles.public__dropdown} ${isDropdownOpen ? styles.public__dropdown__open : ''}`}>
                <CustomLink 
                  to={RouteDictionary.ENTER} 
                  className={styles.public__dropdown__item}
                >
                  войти как инвестор
                  <button 
                    className={styles.public__dropdown__close}
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      closeDropdown();
                    }}
                  >
                    <Image src={cross} alt='close'/>
                  </button>
                </CustomLink>
                <CustomLink 
                  to={RouteDictionary.ENTER_BORROWER} 
                  className={styles.public__dropdown__item}
                >
                  войти как заемщик
                </CustomLink>
              </div>
            </div>
            :
            <div className={styles.user__menu}>
              <ProfileMenu/>
            </div>}
          <div className={styles.burger} ref={burgerRef}>
            <button
              type='button'
              className={styles.burger__button}
              onClick={toggleBurger}
              aria-label='Меню'
              aria-expanded={isBurgerOpen}
            >
              <Image src={isBurgerOpen ? cross : burger} alt='menu' className={styles.burger__icon}/>
            </button>
            <div className={`${styles.burger__menu} ${isBurgerOpen ? styles.burger__menu__open : ''}`}>
              {renderNavLinks(styles.burger__link)}
            </div>
          </div>
        </div>
      </div>
    </Container>
  </header>;
};
